// Visual metadata + full provider catalog for the Connections dashboard.
// Merged with GET /api/connections/providers so blocks render even before backend restart.

export const CONNECTION_TONES = {
  violet: {
    bg: 'from-violet-500/8', border: 'border-violet-500/25', borderHover: 'hover:border-violet-500/50',
    iconBg: 'bg-violet-500/15', iconBorder: 'border-violet-500/30', iconText: 'text-violet-300',
    badge: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  },
  sky: {
    bg: 'from-sky-500/8', border: 'border-sky-500/25', borderHover: 'hover:border-sky-500/50',
    iconBg: 'bg-sky-500/15', iconBorder: 'border-sky-500/30', iconText: 'text-sky-300',
    badge: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  },
  emerald: {
    bg: 'from-emerald-500/8', border: 'border-emerald-500/25', borderHover: 'hover:border-emerald-500/50',
    iconBg: 'bg-emerald-500/15', iconBorder: 'border-emerald-500/30', iconText: 'text-emerald-300',
    badge: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  },
  amber: {
    bg: 'from-amber-500/8', border: 'border-amber-500/25', borderHover: 'hover:border-amber-500/50',
    iconBg: 'bg-amber-500/15', iconBorder: 'border-amber-500/30', iconText: 'text-amber-300',
    badge: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  },
  rose: {
    bg: 'from-rose-500/8', border: 'border-rose-500/25', borderHover: 'hover:border-rose-500/50',
    iconBg: 'bg-rose-500/15', iconBorder: 'border-rose-500/30', iconText: 'text-rose-300',
    badge: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  },
  green: {
    bg: 'from-green-500/8', border: 'border-green-500/25', borderHover: 'hover:border-green-500/50',
    iconBg: 'bg-green-500/15', iconBorder: 'border-green-500/30', iconText: 'text-green-300',
    badge: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  },
  orange: {
    bg: 'from-orange-500/8', border: 'border-orange-500/25', borderHover: 'hover:border-orange-500/50',
    iconBg: 'bg-orange-500/15', iconBorder: 'border-orange-500/30', iconText: 'text-orange-300',
    badge: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  },
  zinc: {
    bg: 'from-zinc-500/8', border: 'border-zinc-500/25', borderHover: 'hover:border-zinc-500/50',
    iconBg: 'bg-zinc-500/15', iconBorder: 'border-zinc-500/30', iconText: 'text-zinc-300',
    badge: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  },
};

export const PROVIDER_META = {
  sendgrid: { icon: 'Mail', tone: 'violet', brand: 'sendgrid' },
  mailgun: { icon: 'Mail', tone: 'violet', brand: 'mailgun' },
  ses: { icon: 'Cloud', tone: 'orange', brand: 'amazonwebservices' },
  smtp: { icon: 'Server', tone: 'zinc' },
  resend: { icon: 'Send', tone: 'violet', brand: 'resend', light: true },
  twilio: { icon: 'Phone', tone: 'emerald', brand: 'twilio' },
  textlocal: { icon: 'MessageSquare', tone: 'emerald' },
  httpsms: { icon: 'Phone', tone: 'emerald' },
  elevenlabs: { icon: 'Mic', tone: 'rose', brand: 'elevenlabs', light: true },
  slack: { icon: 'Slack', tone: 'rose', brand: 'slack' },
  'slack-oauth': { icon: 'Slack', tone: 'rose', brand: 'slack' },
  'slack-mcp': { icon: 'Slack', tone: 'rose', brand: 'slack' },
  evolution: { icon: 'MessageCircle', tone: 'green', brand: 'whatsapp' },
  discord: { icon: 'Hash', tone: 'violet', brand: 'discord' },
  calcom: { icon: 'Calendar', tone: 'sky', brand: 'caldotcom', light: true },
  stripe: { icon: 'CreditCard', tone: 'amber', brand: 'stripe' },
  'stripe-oauth': { icon: 'CreditCard', tone: 'amber', brand: 'stripe' },
  openai: { icon: 'Sparkles', tone: 'emerald', brand: 'openai', light: true },
  anthropic: { icon: 'Sparkles', tone: 'emerald', brand: 'anthropic', light: true },
  google: { icon: 'Globe', tone: 'sky', brand: 'google' },
  gmail: { icon: 'Mail', tone: 'sky', brand: 'gmail' },
  'google-calendar': { icon: 'Calendar', tone: 'sky', brand: 'googlecalendar' },
  'google-drive': { icon: 'Cloud', tone: 'sky', brand: 'googledrive' },
  outlook: { icon: 'Mail', tone: 'sky', brand: 'microsoftoutlook' },
  hubspot: { icon: 'Briefcase', tone: 'orange', brand: 'hubspot' },
  salesforce: { icon: 'Briefcase', tone: 'sky', brand: 'salesforce' },
  attio: { icon: 'Briefcase', tone: 'orange' },
  pipedrive: { icon: 'Briefcase', tone: 'green', brand: 'pipedrive' },
  github: { icon: 'Github', tone: 'zinc', brand: 'github', light: true },
  'github-app': { icon: 'Github', tone: 'zinc', brand: 'github', light: true },
  notion: { icon: 'Globe', tone: 'zinc', brand: 'notion', light: true },
  airtable: { icon: 'Globe', tone: 'amber', brand: 'airtable' },
  intercom: { icon: 'MessageCircle', tone: 'sky', brand: 'intercom' },
  zendesk: { icon: 'MessageCircle', tone: 'green', brand: 'zendesk', light: true },
  servicenow: { icon: 'Server', tone: 'green', brand: 'servicenow' },
  linear: { icon: 'Github', tone: 'violet', brand: 'linear' },
  'linear-mcp': { icon: 'Github', tone: 'violet', brand: 'linear' },
  jira: { icon: 'Github', tone: 'sky', brand: 'jira' },
  confluence: { icon: 'Globe', tone: 'sky', brand: 'confluence' },
  shopify: { icon: 'CreditCard', tone: 'green', brand: 'shopify' },
  xero: { icon: 'CreditCard', tone: 'sky', brand: 'xero' },
  quickbooks: { icon: 'CreditCard', tone: 'green', brand: 'quickbooks' },
  'sage-intacct': { icon: 'CreditCard', tone: 'green', brand: 'sage' },
  workday: { icon: 'Briefcase', tone: 'orange', brand: 'workday' },
  'ukg-pro': { icon: 'Briefcase', tone: 'sky' },
  hibob: { icon: 'Briefcase', tone: 'rose' },
  ashby: { icon: 'Briefcase', tone: 'violet' },
  gong: { icon: 'Mic', tone: 'violet' },
  netsuite: { icon: 'Server', tone: 'orange' },
  'sap-s4hana': { icon: 'Server', tone: 'sky', brand: 'sap' },
  sharepoint: { icon: 'Cloud', tone: 'sky', brand: 'microsoftsharepoint' },
  'microsoft-teams': { icon: 'MessageCircle', tone: 'violet', brand: 'microsoftteams' },
};

export const CATEGORY_ORDER = [
  'Email',
  'SMS & Voice',
  'Messaging',
  'Scheduling',
  'Payments',
  'AI',
  'Marketing',
  'CRM',
  'ATS',
  'Sales',
  'Support',
  'Productivity',
  'E-commerce',
  'Accounting',
  'HR',
  'ERP',
  'Storage',
  'Dev Tools',
  'Design',
  'Integrations',
];

/** Full catalog — keep in sync with backend/connections.py CONNECTION_PROVIDERS */
export const STATIC_CONNECTION_PROVIDERS = [
  { id: 'sendgrid', label: 'SendGrid', auth_type: 'api_key', category: 'Email',
    description: 'Transactional and marketing email via SendGrid.',
    fields: [{ key: 'api_key', label: 'API key', secret: true, required: true }] },
  { id: 'mailgun', label: 'Mailgun', auth_type: 'api_key', category: 'Email',
    description: 'Send email through your Mailgun domain.',
    fields: [
      { key: 'mailgun_domain', label: 'Domain', secret: false, required: true },
      { key: 'mailgun_api_key', label: 'API key', secret: true, required: true },
    ] },
  { id: 'ses', label: 'Amazon SES', auth_type: 'api_key', category: 'Email',
    description: 'Email delivery through AWS Simple Email Service.',
    fields: [
      { key: 'ses_access_key_id', label: 'Access key ID', secret: false, required: true },
      { key: 'ses_secret_access_key', label: 'Secret access key', secret: true, required: true },
      { key: 'ses_region', label: 'Region', secret: false, required: false, placeholder: 'us-east-1' },
    ] },
  { id: 'smtp', label: 'SMTP', auth_type: 'api_key', category: 'Email',
    description: 'Any SMTP server (Gmail, Outlook, custom host).',
    fields: [
      { key: 'smtp_host', label: 'Host', secret: false, required: true },
      { key: 'smtp_port', label: 'Port', secret: false, required: true, placeholder: '587' },
      { key: 'smtp_username', label: 'Username', secret: false, required: true },
      { key: 'smtp_password', label: 'Password', secret: true, required: true },
      { key: 'smtp_use_tls', label: 'Use TLS (true/false)', secret: false, required: false, placeholder: 'true' },
    ] },
  { id: 'resend', label: 'Resend', auth_type: 'api_key', category: 'Email',
    description: 'Developer-friendly transactional email API.',
    fields: [{ key: 'resend_api_key', label: 'API key', secret: true, required: true }] },
  { id: 'twilio', label: 'Twilio', auth_type: 'api_key', category: 'SMS & Voice',
    description: 'SMS, MMS, and voice calls via Twilio.',
    fields: [
      { key: 'account_sid', label: 'Account SID', secret: false, required: true },
      { key: 'auth_token', label: 'Auth token', secret: true, required: true },
      { key: 'from_number', label: 'From number (E.164)', secret: false, required: false, placeholder: '+14155551234' },
    ] },
  { id: 'textlocal', label: 'Textlocal', auth_type: 'api_key', category: 'SMS & Voice',
    description: 'Bulk SMS for UK/India via Textlocal.',
    fields: [
      { key: 'textlocal_api_key', label: 'API key', secret: true, required: true },
      { key: 'textlocal_sender', label: 'Sender ID', secret: false, required: true },
    ] },
  { id: 'httpsms', label: 'httpSMS', auth_type: 'api_key', category: 'SMS & Voice',
    description: 'Send SMS via your Android phone (https://httpsms.com).',
    fields: [
      { key: 'httpsms_api_key', label: 'API key', secret: true, required: true },
      { key: 'httpsms_from_number', label: 'From number (SIM)', secret: false, required: true, placeholder: '+14155551234' },
    ] },
  { id: 'elevenlabs', label: 'ElevenLabs', auth_type: 'api_key', category: 'SMS & Voice',
    description: 'AI voice synthesis for outbound call automations.',
    fields: [{ key: 'api_key', label: 'API key', secret: true, required: true }] },
  { id: 'slack', label: 'Slack (Webhook)', auth_type: 'api_key', category: 'Messaging',
    description: 'Post workflow alerts via webhook or bot token.',
    fields: [
      { key: 'bot_token', label: 'Bot token (xoxb-…)', secret: true, required: false },
      { key: 'webhook_url', label: 'Incoming webhook URL (optional)', secret: true, required: false },
      { key: 'default_channel', label: 'Default channel ID', secret: false, required: false, placeholder: 'C0123456789' },
    ] },
  { id: 'evolution', label: 'Evolution (WhatsApp)', auth_type: 'api_key', category: 'Messaging',
    description: 'WhatsApp Business via Evolution API.',
    fields: [
      { key: 'base_url', label: 'Base URL', secret: false, required: true, placeholder: 'http://localhost:8080' },
      { key: 'api_key', label: 'API key', secret: true, required: true },
    ] },
  { id: 'discord', label: 'Discord', auth_type: 'api_key', category: 'Messaging',
    description: 'Send notifications to a Discord channel webhook.',
    fields: [{ key: 'webhook_url', label: 'Webhook URL', secret: true, required: true }] },
  { id: 'calcom', label: 'Cal.com', auth_type: 'api_key', category: 'Scheduling',
    description: 'Booking links for lead triage and sales automations.',
    fields: [
      { key: 'calcom_username', label: 'Username', secret: false, required: true, placeholder: 'yourname' },
      { key: 'api_key', label: 'API key (optional)', secret: true, required: false },
    ] },
  { id: 'stripe', label: 'Stripe', auth_type: 'api_key', category: 'Payments',
    description: 'Payment events and checkout automations.',
    fields: [{ key: 'secret_key', label: 'Secret key', secret: true, required: true }] },
  { id: 'openai', label: 'OpenAI', auth_type: 'api_key', category: 'AI',
    description: 'GPT models for AI agent automation steps.',
    fields: [{ key: 'api_key', label: 'API key', secret: true, required: true }] },
  { id: 'google', label: 'Google', auth_type: 'oauth2', category: 'Integrations',
    description: 'Google Calendar, Gmail, and Workspace integrations.',
    default_scopes: ['openid', 'email', 'profile', 'https://www.googleapis.com/auth/calendar.readonly'] },
  { id: 'hubspot', label: 'HubSpot', auth_type: 'oauth2', category: 'Integrations',
    description: 'Sync contacts and deals with HubSpot CRM.',
    default_scopes: ['crm.objects.contacts.read', 'crm.objects.contacts.write', 'crm.objects.deals.read'] },
  { id: 'github', label: 'GitHub', auth_type: 'oauth2', category: 'Integrations',
    description: 'Repository events and deploy automations.',
    default_scopes: ['repo', 'read:user', 'user:email'] },
];

/** Merge API catalog with static fallback (API wins on field definitions). */
export function mergeProviderCatalog(apiProviders) {
  const apiById = Object.fromEntries((apiProviders || []).map((p) => [p.id, p]));
  const staticIds = new Set(STATIC_CONNECTION_PROVIDERS.map((p) => p.id));
  const merged = STATIC_CONNECTION_PROVIDERS.map((sp) => ({
    ...sp,
    ...(apiById[sp.id] || {}),
    fields: apiById[sp.id]?.fields?.length ? apiById[sp.id].fields : sp.fields,
  }));
  (apiProviders || []).forEach((p) => {
    if (!staticIds.has(p.id)) merged.push(p);
  });
  return merged;
}

/**
 * Resolve a single provider for the drawer — never use mergeProviderCatalog(...)[0]
 * (that always returns SendGrid, the first static entry).
 */
export function resolveProviderEntry(provider) {
  if (!provider?.id) return provider;
  const staticHit = STATIC_CONNECTION_PROVIDERS.find((p) => p.id === provider.id);
  const fields = provider.fields?.length
    ? provider.fields
    : (staticHit?.fields || provider.fields || []);
  return {
    ...(staticHit || {}),
    ...provider,
    id: provider.id,
    fields,
  };
}

export const getProviderMeta = (id) => PROVIDER_META[id] || { icon: 'Plug', tone: 'zinc' };
